export default __webpack_public_path__ + "static/media/GoalImg9.6cd723c2.png";